// aws api profiles
import api from '../../aws/api/profiles/json.profile.api.aws';

const updateEngagementServiceApi = (engagementId, serviceId, service) =>
  api().post(`/engagements/${engagementId}/services/${serviceId}`, service);

export default updateEngagementServiceApi;
